const initialState = {};

export default function activityLogSlice(state = initialState, action) {
  return state;
}
